import { render, staticRenderFns } from "./my-course.vue?vue&type=template&id=492032cf"
import script from "./my-course.vue?vue&type=script&lang=js"
export * from "./my-course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports